<template>
  <div class="newcomer_report" ref="newcomer_report">
    <img :src="config.property_data.head_img" alt="" ref="head_img" class="head_img" :style="`top:${top(config.property_data.offset_y * 10)}px;
              left:${config.property_data.offset_x}%;
              transform:scale(${config.property_data.scale / 50} );margin-left:-50%;`" />
    <div class="name" :style="`top:${top(1075)}px;font-size:${left(65)}px;`">
      {{ config.property_data.name }}
    </div>
    <div class="department" :style="`top:${top(1187)}px;font-size:${left(42)}px;`">
      {{ config.property_data.department }}
    </div>
    <div class="subDepartment" :style="`left:${left(675)}px;top:${top(1325)}px;width:${left(330)}px`">
      <p :style="`font-size:${left(50)}px;`">
        {{ config.property_data.subDepartment }}
      </p>
      <p :style="`font-size:${left(58)}px;margin-top:10px`">欢迎你!</p>
    </div>
    <div class="property_list">
      <div v-for="(item, index) in propertyList" :key="index" class="property_item">
        <div class="property_item_name">{{ item.split("：")[0] }}</div>
        <div class="property_item_value" :style="`font-family:select_${config.property_data.font_key};font-size:${config.property_data.font_size}px;`">{{ item.split("：")[1] }}</div>
      </div>
      <div v-if="config.property_data.nickname" class="property_item">
        <div class="property_item_name">江湖称号</div>
        <div class="property_item_value">{{ config.property_data.nickname }}</div>
      </div>
      <div v-if="config.property_data.birthday" class="property_item">
        <div class="property_item_name">生日</div>
        <div class="property_item_value">{{ config.property_data.birthday }}</div>
      </div>
      <div v-if="config.property_data.constellation" class="property_item">
        <div class="property_item_name">星座</div>
        <div class="property_item_value">{{ config.property_data.constellation }}</div>
      </div>
      <div v-if="config.property_data.hometown" class="property_item">
        <div class="property_item_name">籍贯</div>
        <div class="property_item_value">{{ config.property_data.hometown }}</div>
      </div>
      <div v-if="config.property_data.single" class="property_item">
        <div class="property_item_name">单身吗</div>
        <div class="property_item_value">{{ config.property_data.single }}</div>
      </div>
      <div v-if="config.property_data.hobby" class="property_item">
        <div class="property_item_name">兴趣爱好</div>
        <div class="property_item_value">{{ config.property_data.hobby }}</div>
      </div>
      <div v-if="config.property_data.specialty" class="property_item">
        <div class="property_item_name">我的过人之处</div>
        <div class="property_item_value">{{ config.property_data.specialty }}</div>
      </div>
    </div>
    
    <div class="img-box">
      <img src="https://mktv-in-cdn.mockuai.com/16780967739083269.png" alt="" ref="img" />
    </div>
  </div>
</template>


<script>
export default {
  name: "tms-newcomer_report",
  props: ["config"],
  data() {
    return {
      height: 0,
      width: 0,
      head_img_width: 0,
      head_img_height: 0,
      propertyList: [],
    };
  },
  methods: {
    left(value) {
      return value / (1080 / this.width);
    },
    top(value) {
      return value / (1920 / this.height);
    },
  },
  mounted() {
    if(!this.config.property_data.font_key){
      this.config.property_data.font_key = 'b';
    }
    if(!this.config.property_data.font_size){
      this.config.property_data.font_size = 14;
    }
    this.$refs.img.onload = () => {
      this.height = this.$refs.img.height;
      this.width = this.$refs.img.width;
    };
  },
  watch: {
    "config.property_data.scale": {
      handler(newVal) {
        this.$nextTick(() => {
          console.log(this.$refs.head_img.offsetLeft);
        });
      },
      immediate: true,
    },
    "config.property_data.property": {
      handler(newVal) {
        this.$nextTick(() => {
          this.propertyList = this.config.property_data.property.split("\n");
          console.log('list', this.propertyList);
        });
      },
      immediate: true,
    },
  },
};
</script>

<style  lang="scss" scoped>
@import "./index.scss";
</style>